export const baseUrl = '/api/reco/entities'
export const baseUrlRisk = '/api/reco/risk-scores/'
export const operationsNamesArray = ['is', 'contains', 'startsWith', 'endsWith']
export const riskTypeOperations = ['is']
export const riskTypeData = ['Very High', 'High', 'Medium', 'Low']
export const entityTypeData = ['User Account', 'Group', 'Service Principal', 'Role']
export const originFilterUrl = '/api/reco/risk-scores/origins-wise/v1'
export const accountFilterUrl = '/api/reco/risk-scores/accounts-wise/v1'
export const recommendationUrl = '/api/reco/entities/v1'
export const baseUrlWatch = '/api/reco/watch'
export const accessmapUrl =
  '/api/ada/graph/accessmap/ramdetailsbyentitytype?entityType=UserAccount&key=1030'
export default {
  baseUrl,
  baseUrlRisk,
  baseUrlWatch,
  operationsNamesArray,
  riskTypeOperations,
  entityTypeData,
  originFilterUrl,
  accountFilterUrl,
  recommendationUrl,
  accessmapUrl,
}
